import { bodyBgPattern } from './BodyBgStore.js';

export const updateBodyBgPattern = (value) => bodyBgPattern.update(oldValue => value);
